<template>
  <div class="freight_mode">
    <div class="row __centerblock">
      <div class="col text-center">
        <h3 class="text-center __titleGlobal">Select Freight Mode</h3>
          <button
            class="__block"
            type="button"
            name="button"
            v-bind:class="{ active: isActiveAir }"
            @click="chkFrgMode('air')"
          >
            <img src = "@/assets/image/instantprice/airplane@3x.png">
            <p class="__title">Air</p>
          </button>
          <button
            class="__block"
            type="button"
            name="button"
            v-bind:class="{ active: isActiveOcean }"
            @click="chkFrgMode('ocean')"
          >
            <img src = "@/assets/image/instantprice/ship@3x.png">
            <p class="__title">Ocean</p>
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import ShipmentAir from '@/components/instantPrice/ShipmentAir'

export default {
  name: 'freight_mode',
  components: {
    ShipmentAir
  },
  data () {
    return {
      selectedtabs: ShipmentAir,
      isActiveAir: true,
      isActiveOcean: false,
      freightMode: 'Air'
    }
  },
  methods: {
    chkFrgMode (type) {
      this.isActiveAir = type === 'air'
      this.isActiveOcean = type === 'ocean'

      this.freightMode = this.isActiveAir ? 'Air' : 'Ocean'

      this.$emit('IntantPriceFreightMode', this.freightMode)
    }
  },
  computed: {
    currentStepComponent: function () {
      return this.selectedtabs
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/instantPrice/FreightMode.vue